import { cx, Flex } from '@vtex/admin-ui'
import { DefaultProps } from 'typings'
import styles from './styles.css'

type IconContainerType = {
  rounded?: boolean
  className?: string
}

export function IconContainer(props: DefaultProps & IconContainerType) {
  const { rounded, className } = props
  return (
    <Flex
      className={cx(
        styles.iconContainer,
        className ?? '',
        rounded ? styles.rounded : ''
      )}
      align="center"
      justify="center"
    >
      {props.children}
    </Flex>
  )
}
